<template>
    <div data-cy="secretquestionsTabContent">
        <v-card v-if="userInformations && resetLink && resetLink.STATUS === 'ACTIVE' && resetLink.USED === 'NO'">
            <v-container>
                <div v-if="!configSuccess">
                    <v-card-title>{{ $t('passAccount.configuration.title') }}</v-card-title>
                    <v-card-text>
                        <p>{{ $t('passAccount.configuration.your_profil') }}</p>
                        <table>
                            <tbody>
                                <tr>
                                    <td class="key">{{ $t('passwordLost.change.my_id') }}</td>
                                    <td>{{ userInformations.geodisLogin }}</td>
                                </tr>
                                <tr>
                                    <td class="key">{{ $t('passwordLost.change.firstname') }}</td>
                                    <td>{{ userInformations.firstname }}</td>
                                </tr>
                                <tr>
                                    <td class="key">{{ $t('passwordLost.change.lastname') }}</td>
                                    <td>{{ userInformations.lastname }}</td>
                                </tr>
                                <tr>
                                    <td class="key">{{ $t('passwordLost.change.mail') }}</td>
                                    <td>{{ userInformations.mail }}</td>
                                </tr>
                            </tbody>
                        </table>
                        <br />
                        <br />
                        <p>{{ $t('passAccount.configuration.define') }}</p>
                        <br />
                        <p>{{ $t('passAccount.configuration.in_case_of') }}</p>
                        <ChangeSecretQuestions
                            ref="SQForm"
                            @sq-is-valid="onSQIsValid"
                            @sq-changed="onSQChanged"
                            onlyFields="true"
                        ></ChangeSecretQuestions>
                        <br />
                        <br />
                        <p>{{ $t('passAccount.configuration.for_security') }}</p>
                        <ChangePassword
                            ref="PasswordForm"
                            @password-is-valid="onPasswordIsValid"
                            @password-changed="onPasswordChanged"
                            :is-configuration="true"
                            onlyFields="true"
                        ></ChangePassword>
                        <div class="actions">
                            <v-btn class="action" :disabled="!isValid" @click="submit">{{
                                $t('passAccount.configuration.finished')
                            }}</v-btn>
                        </div>
                    </v-card-text>
                </div>
                <v-card-text class="passwordChangeSuccess" v-else>
                    <div v-html="successMsg.webTextContent"></div>
                </v-card-text>
            </v-container>
            <v-snackbar v-model="snackbar.display" :timeout="snackbar.timeout">{{ snackbar.text }}</v-snackbar>
        </v-card>
        <v-card v-else-if="errorMsg && resetLink && (resetLink.STATUS === 'OBSOLETE' || resetLink.USED === 'YES')">
            <div class="errorMessage" v-html="errorMsg.webTextContent"></div>
        </v-card>
    </div>
</template>

<script>
import { api } from '@utils/api';
import { i18n } from '@plugins/vuetify';
import { mapMutations, mapGetters, mapState } from 'vuex';
import { NAVIGATION, GET_ANONYMOUS } from '@constants/navigation';

import ChangePassword from '@components/ChangePassword';
import ChangeSecretQuestions from '@components/ChangeSecretQuestions';

export default {
    components: {
        ChangeSecretQuestions,
        ChangePassword
    },
    data() {
        return {
            areValid: {
                SQ: null,
                password: null
            },
            snackbar: {
                display: false,
                text: '',
                timeout: 2000
            },
            resetLink: {},
            configSuccess: false,
            successMsg: null,
            successMsgFr: null,
            successMsgEn: null,
            errorMsg: null,
            errorMsgFr: null,
            errorMsgEn: null
        };
    },
    methods: {
        ...mapMutations(['setUserInformations']),
        ...mapGetters(NAVIGATION, [GET_ANONYMOUS]),
        onSQIsValid(check) {
            this.areValid.SQ = check;
        },
        onPasswordIsValid(check) {
            this.areValid.password = check;
        },
        async onPasswordChanged(result) {
            if (result === true) {
                const result = await api.get(
                    'validateUser',
                    {
                        UUID: this.$route.params.UUID,
                        login: this.userInformations.geodisLogin
                    },
                    { withCredentials: true },
                    'accMgmt'
                );
                if (result) {
                    this.snackbar.text = i18n.t('passAccount.common.configurationComplited');
                    this.snackbar.display = true;
                    const textsWeb = await api.get('textsWebById', { id: this.resetLink.IS_G3 ? 4 : 5 }, null, 'accMgmt');
                    this.successMsgEn = textsWeb.find(tw => tw.language === 'en');
                    this.successMsgFr = textsWeb.find(tw => tw.language === 'fr');
                    this.successMsg = this.$i18n.locale === 'fr' ? this.successMsgFr : this.successMsgEn;
                    this.configSuccess = true;
                } else {
                    this.snackbar.text = i18n.t('passAccount.common.configurationFailed');
                    this.snackbar.display = true;
                }
            }
        },
        onSQChanged(result) {
            if (result === true) {
                this.$refs.PasswordForm.submit();
            }
        },
        async submit() {
            this.$refs.SQForm.submit();
        }
    },
    computed: {
        ...mapState({
            userInformations: state => state.user.informations
        }),
        isValid() {
            return this.areValid.SQ && this.areValid.password;
        }
    },
    async mounted() {
        const { locale } = this.$route.query;
        if (locale) {
            await api.setLang(locale, this.$i18n, this.$vuetify);
            this.successMsg = locale === 'fr' ? this.successMsgFr : this.successMsgEn;
            this.errorMsg = locale === 'fr' ? this.errorMsgFr : this.errorMsgEn;
        }
        this.resetLink = await api.get('findGeodisLogin', { UUID: this.$route.params.UUID }, { withCredentials: true }, 'accMgmt');
        const textsWeb = await api.get('textsWebById', { id: 3 }, null, 'accMgmt');
        this.errorMsgEn = textsWeb.find(tw => tw.language === 'en');
        this.errorMsgFr = textsWeb.find(tw => tw.language === 'fr');
        this.errorMsg = this.$i18n.locale === 'fr' ? this.errorMsgFr : this.errorMsgEn;
        if (!this.resetLink) {
            return this.$router.push('/login');
        }
        if (this.getAnonymous()?.message === 'anonymous succeed') {
            const userInformations = await api.post(
                'userInfo',
                { geodisLogin: this.resetLink.GEODIS_LOGIN },
                { withCredentials: true },
                'accMgmt'
            );
            this.setUserInformations(userInformations);
            this.$session.set(
                'accMgmt-configuration-informations',
                btoa(unescape(encodeURIComponent(JSON.stringify(this.userInformations))))
            );
            const secretQuestions = await api.get('secretQuestions', null, { withCredentials: true }, 'accMgmt');
            this.$store.commit('setSQ', secretQuestions);
        }
    },
    watch: {
        '$i18n.locale'() {
            this.successMsg = this.$i18n.locale === 'fr' ? this.successMsgFr : this.successMsgEn;
            this.errorMsg = this.$i18n.locale === 'fr' ? this.errorMsgFr : this.errorMsgEn;
        }
    }
};
</script>

<style lang="scss" scoped>
.actions {
    margin-top: 20px;
}

table {
    .key {
        padding-right: 40px;
    }
}

.errorMessage {
    padding: 10px;
    background: #f8d7da;
    box-shadow: 0 0px 4px red;
    color: red;
    font-weight: 400;
}

.passwordChangeSuccess {
    box-shadow: 0px 0px 3px #3200e6;
    color: #3200e6;
    font-weight: 600;
}
</style>
